import { ApiService } from './api.service';
import type { MinistrySchedulerUpdateRequest, MinistrySchedulerView } from '@/types/ministryScheduler';

class MinistrySchedulerService extends ApiService {
  public async getMinistryScheduler(churchId: string): Promise<MinistrySchedulerView> {
    const url = `/api/v1/churches/${churchId}/mp-ministries`;
    const response = await this.get<MinistrySchedulerView>(url);
    return response.data;
  }

  public async updateMinistryScheduler(
    churchId: string,
    payload: MinistrySchedulerUpdateRequest,
  ): Promise<MinistrySchedulerView> {
    const url = `/api/v1/churches/${churchId}/mp-ministries`;
    const response = await this.put<MinistrySchedulerView>(url, payload);
    return response.data;
  }
}

export const ministrySchedulerService = new MinistrySchedulerService();
